export default "__VITE_ASSET__DpA$8tGj__"